import React from 'react';
import type { SendJobFailureSummary as Summary } from '@/utils/jobItemErrors';

type Props = {
  summary: Summary;
};

function CountList({ title, rows }: { title: string; rows: Summary['byError'] }) {
  if (!rows.length) return null;
  return (
    <div className="send-failure-summary__group">
      <h4>{title}</h4>
      <ul className="send-failure-summary__list">
        {rows.map((row) => (
          <li key={row.label}>
            <span className="send-failure-summary__count">{row.count}</span>
            <span className="send-failure-summary__label">{row.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function SendJobFailureSummaryPanel({ summary }: Props) {
  return (
    <div className="send-failure-summary card section" role="region" aria-label="Send failure summary">
      <h3 className="send-failure-summary__title">
        Failure summary <span className="muted">({summary.total} failed)</span>
      </h3>
      <div className="send-failure-summary__grid">
        <CountList title="By error" rows={summary.byError} />
        <CountList title="By source" rows={summary.bySource} />
        <CountList title="By recipient" rows={summary.byRecipient} />
      </div>
    </div>
  );
}
